import React, { useId } from 'react';

/* The production CourtClic mark: the Seam direction chosen from /logo.
   A tennis ball squared off into a tile. The seam is the surface showing
   through rather than a painted line, so the mark sits correctly on whatever
   it is placed on; pass a `knockout` when that is not the page surface.
   Geometry is shared with brand/svg/courtclic-mark.svg - change both or
   neither. */
export default function BrandMark({
  className,
  tile = 'var(--cc-accent)',
  knockout = 'var(--cc-surface)',
  title,
  ...rest
}) {
  const clipId = `cc-mark-${useId().replace(/:/g, '')}`;
  return (
    <svg
      className={className}
      viewBox="0 0 48 48"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...rest}
    >
      {title && <title>{title}</title>}
      <defs>
        <clipPath id={clipId}>
          <rect x="2" y="2" width="44" height="44" rx="13" />
        </clipPath>
      </defs>
      <rect x="2" y="2" width="44" height="44" rx="13" fill={tile} />
      <g clipPath={`url(#${clipId})`}>
        <path
          d="M1.529 19.147C11.879 34.902 36.121 13.098 46.471 28.853"
          fill="none"
          stroke={knockout}
          strokeWidth="3.6"
          strokeLinecap="round"
        />
      </g>
    </svg>
  );
}
